import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './i18n';
import './filters';
import './elementui';
import './assets/sass/main.scss';

Vue.config.productionTip = false;
Vue.prototype.$filters = Vue.options.filters;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
